export default "__VITE_ASSET__DiKotuZV__"